import { render, staticRenderFns } from "./EntityPreviewAvatar.vue?vue&type=template&id=90575628&scoped=true&lang=html&"
import script from "./EntityPreviewAvatar.vue?vue&type=script&lang=js&"
export * from "./EntityPreviewAvatar.vue?vue&type=script&lang=js&"
import style0 from "./EntityPreviewAvatar.vue?vue&type=style&index=0&id=90575628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90575628",
  null
  
)

export default component.exports